import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminService } from '../../admin.service';
import {
    MatSnackBar,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
@Component({
    selector: 'app-create-banner',
    templateUrl: './banner.create.component.html',
    styleUrls: ['./banner.create.component.css', '../banner-list/banner.list.component.css']
})

export class BannerCreate implements OnInit {
    file: any;
    imageSrc: any;
    horizontalPosition: MatSnackBarHorizontalPosition = 'end';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
    bannerImageIdAfterUpload = '';
    selectedBannerType = "BOT";
    bannerType: any;
    selectedBot = "";
    bots: any;
    startDateForm = new FormControl();
    endDateForm = new FormControl();
    startTime = '';
    endTime = '';
    minEndDate = new Date();
    urlLink = "";

    ngOnInit(): void {
        this.bannerType = [{
            name: "BOT",
            value: "BOT",
            checked: true
        },
        {
            name: "URL",
            value: "URL",
            checked: false
        },]
        this.getAllBots();
    }
    constructor(private adminService: AdminService, private _snackBar: MatSnackBar, private router : Router) { }
    handleInputImage(event) {
        if (event.target.files && event.target.files.length) {
            this.file = event.target.files[0];
            const reader = new FileReader();
            reader.onload = (e) => (this.imageSrc = reader.result);

            reader.readAsDataURL(this.file);
            this.adminService.uploadBannerHubImage(this.file, this.file.type).subscribe(
                (res) => {
                    this.bannerImageIdAfterUpload = res.id;
                },
                (err) => {
                    if (err.error.message) {
                        this._snackBar.open(err.error.message, 'close', {
                            duration: 4000,
                            horizontalPosition: 'end',
                            verticalPosition: 'top',
                        });
                    }
                }
            )
        }
    }

    getAllBots() {
        this.adminService.getAllBots().subscribe(
            (res) => {
                this.bots = res.data;
                if (this.bots.length > 0)
                    this.selectedBot = this.bots[0].bot_id;
            },
            (err) => {
                if (err.error.message) {
                    this._snackBar.open(err.error.message, 'close', {
                        duration: 4000,
                        horizontalPosition: 'end',
                        verticalPosition: 'top',
                    });
                }
            }
        )
    }

    convertInFormatTime(selectedDate, time) {
        const dateValue = new Date(selectedDate);
        const timeValue = time;
        let [hours, minutes] = timeValue.split(':');
        dateValue.setHours(parseInt(hours, 10), parseInt(minutes, 10));
        const formattedDate = dateValue.toISOString();
        return formattedDate;
    }

    checkAllField(){

        if(this.selectedBannerType=='BOT'){
            if(this.bannerImageIdAfterUpload=='') return false;
            if(this.startTime=='' || this.endTime=='') return false;
            if(!this.startDateForm.value || !this.endDateForm) return false;
            return true;
        } else {
            if(this.bannerImageIdAfterUpload=='') return false;
            if(this.urlLink=='') return false;
            if(this.startTime=='' || this.endTime=='') return false;
            if(!this.startDateForm.value || !this.endDateForm) return false;
            return true;
        }

    }

    timeToMillisecond(time) {
        let [hours, minutes] = time.split(':');
        let milliSecond = (parseInt(hours, 10) * 60 + parseInt(minutes, 10)) * 60 * 1000;
        return milliSecond;
    }

    scheduleBanner(){
        let start_time = this.timeToMillisecond(this.startTime);
        let end_time = this.timeToMillisecond(this.endTime);
        let start_date = new Date(this.startDateForm.value).getTime() + start_time;
        let end_date = new Date(this.endDateForm.value).getTime() + end_time;
        if(start_date > end_date){
            this._snackBar.open("Start Time is Less than End Time", 'close', {
                duration: 4000,
                horizontalPosition: 'end',
                verticalPosition: 'top',
            });
            return;
        }
        let reqBody = {};
        if(this.selectedBannerType=='BOT'){
            reqBody = {
                banner_image_id : this.bannerImageIdAfterUpload,
                type: "BOT",
                bot_id: this.selectedBot,
                start_time : this.convertInFormatTime(this.startDateForm.value, this.startTime),
                end_time: this.convertInFormatTime(this.endDateForm.value, this.endTime)
            }
        } else {
            reqBody = {
                banner_image_id : this.bannerImageIdAfterUpload,
                type: "URL",
                url: this.urlLink,
                start_time : this.convertInFormatTime(this.startDateForm.value, this.startTime),
                end_time: this.convertInFormatTime(this.endDateForm.value, this.endTime)
            }

        }

        this.adminService.scheduleBanner(reqBody).subscribe(
            (res)=>{
                this._snackBar.open("Schedule Success", 'close', {
                    duration: 4000,
                    horizontalPosition: 'end',
                    verticalPosition: 'top',
                });
                this.router.navigateByUrl('/admin/banner-hub/banner-list')
            },
            (err)=>{
                if(err.error.message){
                    this._snackBar.open(err.error.message, 'close', {
                        duration: 4000,
                        horizontalPosition: 'end',
                        verticalPosition: 'top',
                    });
                }
            }
        )
    }


}